<template>
  <v-card>

    <v-progress-circular v-if="loading"
                         indeterminate
                         color="primary">
    </v-progress-circular>

    <v-card-text>
    <defect-report-properties-view v-if="defectReport != null"
                                     :defect-report="defectReport"
                                     :documents="documents">
      <template v-slot:append>
        <entity-properties-row>
          <v-btn v-if="$featurePermissions.defectReportEdit"
                 tile
                 color="primary"
                 @click="openEditDialog">
            {{ $t('actions.modify') }}
            <v-icon right dark>
              mdi-border-color
            </v-icon>
          </v-btn>
        </entity-properties-row>
      </template>
    </defect-report-properties-view>
    <defect-report-dialog ref="defectReportDialog" @done="reload"/>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import DefectReportPropertiesView from '@/views/defectreport/DefectReportPropertiesView';
import DefectReportDialog from '@/views/defectreport/DefectReportDialog';
import DefectReportsService from '@/services/DefectReportsService';

export default Vue.extend({
  name: 'DefectReportDetails',
  components: {
    DefectReportDialog,
    DefectReportPropertiesView,

    EntityPropertiesRow,
  },
  data() {
    return {
      defectReport: null,
      documents: [],
      loading: false,

    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      DefectReportsService.get(this.defectReportId).then(result => {
        this.defectReport = result.data.defectReport;
        this.documents = result.data.documents;
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.loading = false;
      });
    },

    openEditDialog() {
      this.$refs.defectReportDialog.openEditForDefectReport(this.defectReportId);
    },
  },

  computed: {
    defectReportId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
});
</script>
